import React from 'react';
import {ContainerBox, P, ReferenceTitle, Space, AddClassBtn, ContainerBtnBox, InputContainer} from '../Style/ReferenceImageUpload.style';
import { TextFieldVI } from '../../TextFieldVI';
import {InputType} from '../../../pages/CreateAutoProject/Config/CreateAutoProject.constants';
import DragAndDropUploadData from '../../DragAndDropUploadData';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import NewClassImages from '../../NewClassImages';
import useReferenceImageUpload from '../controller/useReferenceImageUpload.controller';
import {IProps} from '../Config/ReferenceImageUpload.types';
import {Subtitle1} from '../../../ui-library';

const ReferenceImageUpload = ({
    getChosenFiles,
    deleteClass,
    autoProjectState,
    setState,
    onDoneProcess,
    uiFileList,
    numberOfFiles,
    uploadCounter,
    onDeleteFile,
    uiFiledFileList,
    retryAllFiledFiles,
    isShowTitle = true,
    getOpen,
    isShowBtn = true,
    disabled = false,
    initValue = '',
    isGlobalError = false,
    globalError = '',
    isCanAddFile = true,
    data_project_id = -1,
    setOpenModal = () => {},
    class_id,
}:IProps) => {
    const {addClass} = useReferenceImageUpload(autoProjectState, setState, onDoneProcess, uploadCounter, numberOfFiles, data_project_id, deleteClass, isCanAddFile, setOpenModal, class_id);


    return (
        <ContainerBox>
            {isShowTitle && <>
                <Subtitle1 align='left'>{_SYSTEM_TITLES.addClassTitle}</Subtitle1>
                <P>
                    {_SYSTEM_TITLES.addClassInputSubTitleLine1}<br/>
                    {_SYSTEM_TITLES.addClassInputSubTitleLine2}<br/>
                    {_SYSTEM_TITLES.addClassInputSubTitleLine3}
                </P>
                <Space />
            </>}
            <InputContainer>
                <TextFieldVI
                    globalError={isGlobalError ? globalError : autoProjectState.classError}
                    getValue={(value) => setState({className: value})}
                    inputType={InputType.ClassName}
                    initValue={initValue}
                    disabled={disabled}
                    clearValue={uiFileList.length === 0 && !initValue}
                    inputLabel={_SYSTEM_TITLES.addClassInput} />
            </InputContainer>
            <ReferenceTitle>{_SYSTEM_TITLES.referenceImages}</ReferenceTitle>
            {uiFileList.length === 0
                ? <DragAndDropUploadData getChosenFiles={getChosenFiles} backgroundColor='#D4EAFC' backgroundColorDefault='' />
                : <NewClassImages
                    getOpen={getOpen}
                    uploadClassError={autoProjectState.uploadClassError}
                    retryAllFiledFiles={retryAllFiledFiles}
                    uiFiledFileList={uiFiledFileList}
                    getChosenFiles={getChosenFiles}
                    onDeleteFile={onDeleteFile}
                    numberOfSuccess={uploadCounter}
                    numberOfFiles={autoProjectState.minReference}
                    itemData={uiFileList}
                />
            }
            {isShowBtn && <ContainerBtnBox>
                <AddClassBtn variant='contained' size='medium' onClick={() => addClass()}>{autoProjectState.activeEditId > -1 ? _SYSTEM_TITLES.updateClassBtn : _SYSTEM_TITLES.addClassBtn}</AddClassBtn>
            </ContainerBtnBox>}
        </ContainerBox>
    );
};

export default ReferenceImageUpload;
